import VueMonthlyPicker from 'vue-monthly-picker'
import Select2Multiple from 'v-select2-multiple-component';
import MainLayout from "@/components/layout/admin/MainLayout.vue";
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
import { required } from "vuelidate/lib/validators";
import Loading from 'vue-loading-overlay';
import CONFIG from "@/assets/js/config.js";
import axios from "axios";
import store from '@/store';
import moment from "moment";

export default {
  name: "monthlyAttendanceList",
  components: {
    MainLayout,
    Select2Multiple,
    VueMonthlyPicker,
    AdvancedLaravelVuePaginate,
    Loading,
  },

  data() {
    return {
      isFilterOpen: false,
      monthlyAttendanceList: {},
      lastSearchParams: {},
      searchData: {
        acd_year_id: null,
        class_id: null,
        student_name: null,
        month: moment().format('YYYY-MM'),
        lastSearchMonth: moment().format('YYYY-MM'),
      },
      academicYearArr: [],
      classArr: [],
      daysInMonth: [],
      selectedMonth: moment().format("YYYY-MM"),
      noDataMsg: CONFIG.NO_DATA_FOUND,
      isLoading: false,
      searchedData: null,
    };
  },

  validations: {
    searchData: {
      month: {
        required,
      },
    },
  },

  methods: {
    getDaysInMonth() {
      if (!this.searchData.month) return [];

      const [year, month] = this.searchData.month.split('-').map(Number);
      const daysCount = moment(`${year}-${month}`, 'YYYY-MM').daysInMonth();

      this.daysInMonth = Array.from({ length: daysCount }, (_, i) => i + 1);
    },

    getAcademicYear() {
      axios.get('getAcademicYear', {
        params: {
          campus_id: store.state.user.campus_id
        }
      }).then(res => {
        let $defaultSelectOption = [{
          'id': 0,
          'text': 'Select Academic Year'
        }];
        this.academicYearArr = $defaultSelectOption.concat(res.data.academicYearArr);
      }).catch((error) => {
        if (error.response && error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
      });
    },

    getClass($yearId) {
      axios.get("class/classList/" + $yearId, {
        params: {
          campus_id: store.state.user.campus_id
        }
      }).then(res => {
        let $defaultSelectOption = [{
          'id': 0,
          'text': 'Select Class'
        }];
        this.classArr = $defaultSelectOption.concat(res.data);
      }).catch(error => {
        if (error.response && error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
      });
    },

    changeEvent(val, fieldName) {
      if (val === "0") {
        this.searchData[fieldName] = null;
      }

      if (fieldName == 'acd_year_id') {
        this.classArr = [];
        this.searchData.class_id = null;
        this.getClass(val);
      }
    },

    reset() {
      this.classArr = [];
      this.searchData.acd_year_id = null;
      this.searchData.class_id = null;
      this.searchData.student_name = null;
      this.searchData.month = moment().format("YYYY-MM");
      this.searchData.lastSearchMonth = moment().format("YYYY-MM");
      this.selectedMonth = moment().format("YYYY-MM");
      this.isLoading = true;
      this.getMonthlyAttendanceList();
      this.isSearched = false;
    },

    getStatusBg(attendanceList, day) {
      const record = attendanceList.find(r => {
        return new Date(r.date).getDate() === day;
      });
      const status = record ? record.status : 'default';
      return CONFIG.ATTENDANCE_STATUS_COLOR[status] || 'bg-gray';
    },

    getMonthlyAttendanceList(page = 1) {
      if (this.$v.$invalid) {
        return;
      }

      this.isLoading = true;
      var params = {
        campus_id: store.state.user.campus_id,
        acd_year_id: this.searchData.acd_year_id,
        class_id: this.searchData.class_id,
        student_name: this.searchData.student_name,
        month: this.searchData.month,
        is_paginate: true,
      };
      this.searchedData = {
        ...params,
      };
      this.searchData.lastSearchMonth = this.searchData.month;
      axios.get("/monthly/attendance/list?page=" + page, { params })
        .then(response => {
          this.monthlyAttendanceList = response.data;
          this.lastSearchParams = params;
          this.getDaysInMonth();
          this.isLoading = false;
        })
        .catch(error => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
          console.log("Monthly Attendance List API Error", error);
        });
    },

    excelDownload() {
      this.isLoading = true;
      const params = { ...this.searchedData }
      axios.get('/monthly/attendance/excelDownload', {
        params,
        responseType: 'arraybuffer'
      })
        .then(response => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          const formattedMonth = this.searchData.lastSearchMonth.replace('-', '_');
          fileLink.setAttribute('download', `monthly_attendance_list_${formattedMonth}.xlsx`);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.isLoading = false;
        }).catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },
  },

  watch: {
    selectedMonth(newValue) {
      if (newValue) {
        const adjustedMonth = moment(newValue, 'YYYY-MM').format('YYYY-MM');
        this.searchData.month = adjustedMonth;
      } else {
        this.searchData.month = null;
      }
    },
  },

  mounted() {
    this.isLoading = true;
    this.getAcademicYear();
    this.getMonthlyAttendanceList();
  },
};
